/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-18 18:23:06
 * @Description: 检测点管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const jcdService = {

  // 检测点
  getJcdConditions: (xmid) => { return axios.get(`${iffApi}/xfjc/ssjc/${xmid}/jcd/conditions`); },
  // 分页检测点
  queryJcd: (params) => { return axios.get(`${iffApi}/xfjc/ssjc/jcd`, { params: params }); },
  // 获取检测点详情信息
  getJcdInfo: (id) => { return axios.get(`${iffApi}/xfjc/ssjc/jcd/${id}`); },

  // 获取建筑物列表
  queryJzw: () => { return axios.get(`${iffApi}/xfjc/jzxx`); }

};
